import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry, Sentry } from './lib/sentry'

// Initialize Sentry error tracking
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div className="min-h-screen flex items-center justify-center bg-stone-50 dark:bg-stone-950">
          <div className="text-center px-6 max-w-md">
            <h1 className="font-serif text-2xl text-stone-900 dark:text-stone-100 mb-2">
              Something went wrong
            </h1>
            <p className="text-stone-600 dark:text-stone-400 mb-4">
              The admin hit an error it couldn't recover from. Refresh to try again, or sign out and back in if that doesn't help.
            </p>
            {import.meta.env.DEV && error instanceof Error && (
              <pre className="text-left text-xs font-mono bg-stone-100 dark:bg-stone-900 text-red-700 dark:text-red-400 rounded-lg p-3 mb-4 overflow-auto max-h-48 whitespace-pre-wrap">
                {error.message}
                {'\n'}
                {error.stack}
              </pre>
            )}
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-primary text-white rounded-full hover:bg-primary-hover transition-colors"
            >
              Refresh Page
            </button>
          </div>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
